import React from 'react';
import {UrlFixer} from "../../utils/utils";
import {ListItemThumb} from "../../utils/common-styles";
import {DateDisplay} from "../Extra/DateDisplay";
import GalleryWidget from "../Extra/GalleryWidget";
import {MarkdownDisplay} from "../Extra/MarkdownDisplay";
import {Row, Col} from "react-bootstrap";
import {ShareButtons} from "../Extra/ShareButtons";
import {Helmet} from "react-helmet";
import {NewsItemTitle, NewsItemMainImageCaption, NewsItemPostMeta, StyledIntro} from "../../utils/common-styles";
import "./NewsItemDetails.css";

export const NewsItemDetail = ({post}) => {

    const newsItem = post;

    return (
        <>
            <Helmet>
                <title>{newsItem.title}</title>
                <meta name="description" content={newsItem.intro?.substring(0, 155)} />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={newsItem.title} />
                <meta property="og:description" content={newsItem.intro?.substring(0, 155)} />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:image" content={UrlFixer('/og-large-profile.jpg')} />
            </Helmet>
            {newsItem.image_details && <ListItemThumb>
                <img src={UrlFixer(newsItem.image_details.variations.detail_hero)} alt={newsItem.caption}/>
                <NewsItemMainImageCaption>{newsItem.image_details.caption}</NewsItemMainImageCaption>
            </ListItemThumb>}

            <NewsItemTitle><h2>{newsItem.title}</h2></NewsItemTitle>
            <NewsItemPostMeta>
                <Row>
                    <Col xs={12} md={3}>
                        <i className="fas fa-calendar-alt"> </i> <DateDisplay datetime={newsItem.published_at}/>
                    </Col>
                    <Col xs={12} md={6}>
                        {newsItem.tags && <> <ul className="tag-list"><i className="fas fa-tags"></i>{newsItem.tags.map((tag) => {
                            return <li key={tag.id}>{tag.name}</li>
                        })}</ul></>}
                    </Col>
                    <Col xs={12} md={3}>
                        <ShareButtons title={newsItem.title} shareUrl={window.location.href} />
                    </Col>
                </Row>
            </NewsItemPostMeta>

            <StyledIntro>
                <MarkdownDisplay text={newsItem.intro} plugins={[]} />
            </StyledIntro>
            <section>
                <MarkdownDisplay text={newsItem.body} plugins={[]} />
            </section>
            <GalleryWidget images={newsItem.gallery_details} />
        </>
    )
}
